import React from 'react';
import SEO from '../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './Financial.css';

const Financial = () => {
    return (
        <div className="industry-page">
            <SEO 
                title="Financial Services | Digi Network" 
                description="Learn more about our Financial services to grow your business online with Digi Network." 
                canonical="/industries/financial/financial" 
            />

            <section className="industry-hero">
                <div className="industry-hero-bg"></div>
                <div className="container">
                    <div className="industry-hero-content">
                        <div className="label">Financial Services Industry</div>
                        <h1>Digital Marketing for Financial Services</h1>
                        <p>Build trust, attract clients, and grow your financial practice with compliant digital marketing strategies for financial advisors and institutions. We understand the unique challenges financial services businesses face in today's competitive market.</p>
                        <div className="industry-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                                Get Started
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                            <Link to="/case-studies" className="btn btn-outline">View Results</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="hero-image-section">
                <div className="container">
                    <div className="image-placeholder-large">
                        <p>📷 Add Financial Hero Image (1200x500px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-services">
                <div className="container">
                    <h2>Financial Services Marketing</h2>
                    <p className="section-intro">Comprehensive marketing solutions tailored for financial professionals</p>
                    <div className="services-grid">
                        <div className="service-card">
                            <h3>Financial SEO</h3>
                            <p>Rank for financial keywords, build authority, and attract qualified prospects in your area. Our financial SEO strategies help advisors and institutions dominate search results for relevant financial services.</p>
                            <ul>
                                <li>Local SEO for financial advisors</li>
                                <li>Financial service optimization</li>
                                <li>Google My Business for finance</li>
                                <li>Financial content marketing</li>
                                <li>Financial directory listings</li>
                                <li>Authority building</li>
                            </ul>
                            <Link to="/industries/financial/seo" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Financial Paid Ads</h3>
                            <p>Drive qualified leads with compliant advertising campaigns that build trust. Our targeted ad campaigns comply with financial industry regulations while maximizing lead generation.</p>
                            <ul>
                                <li>Google Ads for financial services</li>
                                <li>LinkedIn B2B advertising</li>
                                <li>Facebook financial ads</li>
                                <li>Lead generation campaigns</li>
                                <li>Retargeting strategies</li>
                                <li>Conversion tracking & optimization</li>
                            </ul>
                            <Link to="/industries/financial/paid-ads" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Financial Website Design</h3>
                            <p>Professional financial websites that build trust, showcase expertise, and generate leads. Our financial websites are designed to present your practice as authoritative and trustworthy.</p>
                            <ul>
                                <li>Financial advisor websites</li>
                                <li>Client portal integration</li>
                                <li>Compliance-focused design</li>
                                <li>Lead capture optimization</li>
                                <li>Mobile-responsive design</li>
                                <li>Resource center pages</li>
                            </ul>
                            <Link to="/industries/financial/web-development" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Financial Email Marketing</h3>
                            <p>Nurture prospects with educational content, market updates, and automated sequences. Build lasting relationships with potential clients through strategic email communication that provides value.</p>
                            <ul>
                                <li>Financial newsletter campaigns</li>
                                <li>Lead nurturing sequences</li>
                                <li>Market update emails</li>
                                <li>Client communication automation</li>
                                <li>Educational content delivery</li>
                                <li>Referral program campaigns</li>
                            </ul>
                            <Link to="/industries/financial/email-marketing" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Financial CRM & Automation</h3>
                            <p>Manage leads, automate follow-ups, and track client relationships with GoHighLevel. Streamline your client management and communication workflows to improve satisfaction.</p>
                            <ul>
                                <li>Lead management system</li>
                                <li>Automated follow-up sequences</li>
                                <li>Client relationship tracking</li>
                                <li>Compliance-focused automation</li>
                                <li>Client communication tracking</li>
                                <li>Referral tracking</li>
                            </ul>
                            <Link to="/industries/financial/all-in-one" className="service-link">Learn More →</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="process-section">
                <div className="container">
                    <h2 className="process-item-title"> Our Financial Services Marketing Process</h2>
                    <p className="section-intro">A proven methodology designed specifically for financial professionals</p>
                    <div className="process-grid">
                        <div className="process-item">
                            <div className="process-number">1</div>
                            <h3>Practice Analysis</h3>
                            <p>We analyze your financial practice, target clients, and competitive landscape to understand your unique positioning. Our team conducts comprehensive audits of your current marketing and client acquisition strategies.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">2</div>
                            <h3>Compliance-First Strategy</h3>
                            <p>We develop a customized marketing strategy that complies with financial industry regulations and advertising guidelines. Every tactic is designed to maintain compliance while maximizing lead generation.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">3</div>
                            <h3>Trust Building</h3>
                            <p>We implement strategies to build authority and credibility with potential clients. From content marketing to thought leadership, we position your practice as the go-to financial expert.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">4</div>
                            <h3>Client Acquisition & Retention</h3>
                            <p>We generate qualified leads and nurture them through automated follow-up sequences. Our CRM system helps you track every lead and convert more prospects into clients.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Financial Process Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="why-choose">
                <div className="container">
                    <h2>Why Financial Services Choose Digi Network</h2>
                    <p className="why-intro">Trusted by financial professionals across the UAE and internationally</p>
                    <div className="why-grid">
                        <div className="why-item">
                            <div className="why-number">01</div>
                            <h3>Compliance-Focused</h3>
                            <p>All strategies comply with financial industry regulations and advertising guidelines. We understand the strict regulations governing financial marketing and ensure every campaign meets these standards.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">02</div>
                            <h3>Financial Expertise</h3>
                            <p>We understand the financial market and create campaigns that build trust and attract clients. Our team has extensive experience working with financial advisors and institutions.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">03</div>
                            <h3>Trust Building</h3>
                            <p>We focus on building authority and credibility to attract qualified financial clients. Our strategies position your practice as the trusted expert in your field.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">04</div>
                            <h3>Proven Results</h3>
                            <p>We've helped financial advisors increase client acquisition by 240%+ through targeted marketing. Our data-driven approach delivers measurable results that directly impact your practice.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="benefits-section">
                <div className="container">
                    <h2>Key Benefits for Financial Services</h2>
                    <p className="section-intro">How our marketing services help you grow your financial practice</p>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <h3>More Qualified Leads</h3>
                            <p>Generate more qualified leads through targeted marketing campaigns that reach people actively seeking financial advice. Our strategies focus on converting high-intent prospects into clients.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Stronger Online Authority</h3>
                            <p>Build credibility and authority in your field through content marketing and thought leadership. When potential clients search for financial services, they'll find your practice first.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better Client Relationships</h3>
                            <p>Automate follow-ups and nurture relationships with automated email campaigns. Keep in touch with prospects and turn them into long-term clients.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Increased Client Acquisition</h3>
                            <p>Attract more clients through targeted marketing campaigns that showcase your expertise and track record. Build trust with people looking for financial guidance.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better Client Retention</h3>
                            <p>Improve client retention through automated engagement campaigns and personalized communication. Keep clients satisfied and turn them into advocates for your practice.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Competitive Advantage</h3>
                            <p>Stay ahead of competitors with cutting-edge marketing strategies and technology. Many financial advisors still rely on outdated marketing methods.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Financial Benefits Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-cta">
                <div className="container">
                    <h2>Ready to Grow Your Financial Practice?</h2>
                    <p>Let's discuss how we can help you attract more clients and build your financial services business.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Book a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Financial;
